var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-cascader',_vm._b({attrs:{"filterable":"","value":_vm.selectValue,"options":_vm.dataSource,"props":_vm.props},on:{"change":_vm.activeChange}},'el-cascader',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }